/**
 * FormattedDate
 */
import React from 'react';
import moment from 'moment';

interface Props {
    value?: string;
    format?: string;
}

export default class FormattedDate extends React.PureComponent<Props> {
    static defaultProps = {
        format: 'Do MMM YYYY'
    };

    render() {
        const { value, format } = this.props;

        if (!value) return null;

        return moment(value).format(format);
    }
}
